import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.railway.field.survey');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-railway-field-survey',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.railway.field.survey/view.scss */
/* src/app/page.railway.field.survey/view.scss: no such file or directory */`],
})
export class PageRailwayFieldSurveyComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public assessmentTypes: any[] = [
        { key: 'precision_diagnosis', label: '정밀진단' },
        { key: 'safety', label: '안전성' },
        { key: 'durability', label: '내구성' },
        { key: 'usability', label: '사용성' }
    ];
    public answerTypes: any[] = [
        { key: 'scale5', label: '5점 척도' },
        { key: 'yes_no', label: '예 / 아니오' },
        { key: 'text', label: '주관식' }
    ];
    public measurementCountOptions: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    public facilities: any[] = [];
    public selectedFacility: any = null;
    public categories: any[] = [];
    public loading: boolean = true;
    public surveyLoading: boolean = false;

    public showFacilityForm: boolean = false;
    public facilitySaving: boolean = false;
    public facilityForm: any = { name: '', location: '' };

    public showExportModal: boolean = false;
    public exporting: boolean = false;
    public selectedExportAssessment: string = 'precision_diagnosis';

    public showSurvey: boolean = false;
    public questionnaireLoading: boolean = false;
    public submitting: boolean = false;
    public questionnaire: any = {
        category: null,
        item: null,
        assessment: null,
        questions: [],
        submissionCount: 0
    };
    public answers: any = {};
    public surveyPhotos: any = {};
    public measurementForms: any = {};
    public referencePhotoIndexes: any = {};

    public showSurveyResult: boolean = false;
    public surveyResultLoading: boolean = false;
    public surveyResultContext: any = null;
    public surveyResult: any = null;

    public async ngOnInit() {
        await this.service.init();
        await this.loadFacilities();
    }

    public async loadFacilities() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call('facilities');
        if (code === 200) {
            this.facilities = data.facilities || [];
        } else {
            await this.service.modal.error(this.message(data, '시설 목록을 불러오지 못했습니다.'));
        }
        this.loading = false;
        await this.service.render();
    }

    public async openFacilityForm() {
        this.facilityForm = { name: '', location: '' };
        this.showFacilityForm = true;
        await this.service.render();
    }

    public async closeFacilityForm() {
        if (this.facilitySaving) return;
        this.showFacilityForm = false;
        await this.service.render();
    }

    public async createFacility() {
        const name = (this.facilityForm.name || '').trim();
        if (!name || this.facilitySaving) return;
        this.facilitySaving = true;
        await this.service.render();
        const { code, data } = await wiz.call('create_facility', {
            name,
            location: (this.facilityForm.location || '').trim()
        });
        this.facilitySaving = false;
        if (code !== 200) {
            await this.service.render();
            await this.service.modal.error(this.message(data, '시설을 생성하지 못했습니다.'));
            return;
        }

        this.showFacilityForm = false;
        await this.loadFacilities();
        const facility = this.facilities.find(item => item.id === data.id);
        if (facility) await this.selectFacility(facility);
    }

    public async selectFacility(facility: any) {
        this.selectedFacility = facility;
        this.categories = [];
        await this.loadSurveyOverview();
    }

    public async changeFacility() {
        this.selectedFacility = null;
        this.categories = [];
        await this.loadFacilities();
    }

    public async loadSurveyOverview() {
        if (!this.selectedFacility) return;
        this.surveyLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('overview', {
            facility_id: this.selectedFacility.id
        });
        if (code === 200) {
            this.selectedFacility = data.facility;
            this.categories = data.categories || [];
        } else {
            await this.service.modal.error(this.message(data, '조사 항목을 불러오지 못했습니다.'));
        }
        this.surveyLoading = false;
        await this.service.render();
    }

    public get availableSurveyCount(): number {
        let count = 0;
        for (const category of this.categories) {
            for (const item of category.items || []) {
                for (const assessment of this.assessmentTypes) {
                    if (this.getQuestionCount(item, assessment.key) > 0) count++;
                }
            }
        }
        return count;
    }

    public get completedSurveyCount(): number {
        let count = 0;
        for (const category of this.categories) {
            for (const item of category.items || []) {
                for (const assessment of this.assessmentTypes) {
                    if (this.getSubmissionCount(item, assessment.key) > 0) count++;
                }
            }
        }
        return count;
    }

    public get progressPercent(): number {
        if (this.availableSurveyCount === 0) return 0;
        return Math.round(this.completedSurveyCount / this.availableSurveyCount * 100);
    }

    public getQuestionCount(item: any, assessmentType: string): number {
        return item.question_counts?.[assessmentType] || 0;
    }

    public getSubmissionCount(item: any, assessmentType: string): number {
        return item.field_submission_counts?.[assessmentType] || 0;
    }

    public getExportCount(assessmentType: string): number {
        let count = 0;
        for (const category of this.categories) {
            for (const item of category.items || []) {
                count += this.getSubmissionCount(item, assessmentType);
            }
        }
        return count;
    }

    public exportAssessmentLabel(assessmentType: string): string {
        return this.assessmentTypes.find(type => type.key === assessmentType)?.label || assessmentType;
    }

    public async openExportModal() {
        const firstAvailable = this.assessmentTypes.find(
            assessment => this.getExportCount(assessment.key) > 0
        );
        this.selectedExportAssessment = firstAvailable?.key || this.assessmentTypes[0].key;
        this.showExportModal = true;
        await this.service.render();
    }

    public selectExportAssessment(assessmentType: string) {
        if (this.getExportCount(assessmentType) === 0 || this.exporting) return;
        this.selectedExportAssessment = assessmentType;
        this.service.render();
    }

    public async closeExportModal() {
        if (this.exporting) return;
        this.showExportModal = false;
        await this.service.render();
    }

    public async downloadExport() {
        if (
            !this.selectedFacility ||
            this.exporting ||
            this.getExportCount(this.selectedExportAssessment) === 0
        ) return;

        this.exporting = true;
        await this.service.render();
        try {
            const formData = new FormData();
            formData.append('facility_id', this.selectedFacility.id);
            formData.append('assessment_type', this.selectedExportAssessment);
            const response = await fetch('/wiz/api/page.railway.field.survey/export_surveys', {
                method: 'POST',
                body: formData
            });
            const contentType = response.headers.get('content-type') || '';
            if (!response.ok || contentType.includes('application/json')) {
                let message = '현장조사 결과를 추출하지 못했습니다.';
                try {
                    const error = await response.json();
                    message = this.message(error?.data || error, message);
                } catch (e) { }
                throw new Error(message);
            }

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            const safeFacilityName = String(this.selectedFacility.name || '시설')
                .replace(/[\\/:*?"<>|]+/g, '_');
            link.href = url;
            link.download = `${safeFacilityName}_${this.exportAssessmentLabel(this.selectedExportAssessment)}_현장조사.hwpx`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
            this.showExportModal = false;
        } catch (error: any) {
            await this.service.modal.error(error?.message || '현장조사 결과를 추출하지 못했습니다.');
        } finally {
            this.exporting = false;
            await this.service.render();
        }
    }

    public async openSurvey(category: any, item: any, assessment: any) {
        if (this.getQuestionCount(item, assessment.key) === 0) return;
        if (this.getSubmissionCount(item, assessment.key) > 0) {
            await this.openSurveyResult(category, item, assessment);
            return;
        }
        await this.openNewSurvey(category, item, assessment);
    }

    public async openNewSurvey(category: any, item: any, assessment: any) {
        this.questionnaire = {
            category,
            item,
            assessment,
            questions: [],
            submissionCount: 0
        };
        this.answers = {};
        this.measurementForms = {};
        this.referencePhotoIndexes = {};
        this.releaseSurveyPhotoPreviews();
        this.showSurvey = true;
        this.questionnaireLoading = true;
        await this.service.render();
        await this.loadQuestionnaire();
    }

    public async openSurveyResult(category: any, item: any, assessment: any) {
        this.surveyResultContext = { category, item, assessment };
        this.surveyResult = null;
        this.showSurveyResult = true;
        this.surveyResultLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('submission_result', {
            facility_id: this.selectedFacility.id,
            item_id: item.id,
            assessment_type: assessment.key
        });
        this.surveyResultLoading = false;
        if (code !== 200) {
            this.showSurveyResult = false;
            await this.service.render();
            await this.service.modal.error(this.message(data, '저장된 조사 결과를 불러오지 못했습니다.'));
            return;
        }
        this.surveyResult = data;
        await this.service.render();
    }

    public async closeSurveyResult() {
        this.showSurveyResult = false;
        this.surveyResult = null;
        await this.service.render();
    }

    public async startResurvey() {
        if (!this.surveyResultContext) return;
        const context = this.surveyResultContext;
        this.showSurveyResult = false;
        this.surveyResult = null;
        await this.openNewSurvey(context.category, context.item, context.assessment);
    }

    public async loadQuestionnaire() {
        const { code, data } = await wiz.call('questionnaire', {
            facility_id: this.selectedFacility.id,
            item_id: this.questionnaire.item.id,
            assessment_type: this.questionnaire.assessment.key
        });
        this.questionnaireLoading = false;
        if (code !== 200) {
            this.showSurvey = false;
            await this.service.render();
            await this.service.modal.error(this.message(data, '설문지를 불러오지 못했습니다.'));
            return;
        }
        this.selectedFacility = data.facility;
        this.questionnaire.category = data.category;
        this.questionnaire.item = data.item;
        this.questionnaire.questions = data.questions || [];
        this.questionnaire.submissionCount = data.submission_count || 0;
        this.referencePhotoIndexes = {};
        for (const question of this.questionnaire.questions) {
            this.referencePhotoIndexes[question.id] = 0;
        }
        this.resetAnswers();
        await this.service.render();
    }

    public async closeSurvey() {
        if (this.submitting) return;
        this.showSurvey = false;
        this.releaseSurveyPhotoPreviews();
        await this.loadSurveyOverview();
    }

    public answerTypeLabel(answerType: string): string {
        return this.answerTypes.find(type => type.key === answerType)?.label || answerType;
    }

    public referenceImages(question: any): any[] {
        if (Array.isArray(question?.reference_images)) return question.reference_images;
        return question?.reference_image ? [question.reference_image] : [];
    }

    public currentReferenceImage(question: any): any {
        const references = this.referenceImages(question);
        if (!references.length) return null;
        const index = Math.min(
            Math.max(Number(this.referencePhotoIndexes[question.id]) || 0, 0),
            references.length - 1
        );
        return references[index];
    }

    public turnReferencePhoto(question: any, direction: number) {
        const references = this.referenceImages(question);
        if (references.length < 2) return;
        const current = Number(this.referencePhotoIndexes[question.id]) || 0;
        this.referencePhotoIndexes[question.id] = Math.min(
            Math.max(current + direction, 0),
            references.length - 1
        );
        this.service.render();
    }

    public getReferenceImageUrl(reference: any): string {
        const version = reference?.updated || '';
        return `/wiz/api/page.railway.performance/reference_image?id=${encodeURIComponent(reference?.id || '')}&v=${encodeURIComponent(String(version))}`;
    }

    public resultPhotos(answer: any): any[] {
        if (Array.isArray(answer?.photos)) return answer.photos;
        return answer?.photo ? [answer.photo] : [];
    }

    public resultReferenceImages(answer: any): any[] {
        return Array.isArray(answer?.reference_images) ? answer.reference_images : [];
    }

    public getSurveyPhotoUrl(photo: any): string {
        if (!photo) return '';
        const version = photo.created || '';
        return `/wiz/api/page.railway.field.survey/survey_photo?id=${encodeURIComponent(photo.id)}&v=${encodeURIComponent(String(version))}`;
    }

    public resultAnswerLabel(answer: any): string {
        if (answer.answer_type === 'scale5') return `${answer.value}점`;
        if (answer.answer_type === 'yes_no') {
            return answer.value === 'yes' ? '예' : answer.value === 'no' ? '아니오' : answer.value;
        }
        return answer.value;
    }

    public async onSurveyPhotoChange(question: any, event: any) {
        const files = Array.from(event?.target?.files || []) as File[];
        if (event?.target) event.target.value = '';
        if (!files.length) return;
        for (const file of files) {
            await this.addSurveyPhoto(question.id, file);
        }
    }

    public async removeSurveyPhoto(questionId: string, photoIndex: number) {
        const photos = this.surveyPhotos[questionId] || [];
        const current = photos[photoIndex];
        if (current?.preview) URL.revokeObjectURL(current.preview);
        photos.splice(photoIndex, 1);
        if (!photos.length) delete this.surveyPhotos[questionId];
        await this.service.render();
    }

    public toggleFormula(questionId: string) {
        if (this.measurementForms[questionId]) {
            delete this.measurementForms[questionId];
        } else {
            this.measurementForms[questionId] = {
                count: 2,
                values: ['', '']
            };
        }
        this.service.render();
    }

    public updateMeasurementCount(questionId: string) {
        const form = this.measurementForms[questionId];
        if (!form) return;
        const count = Math.min(Math.max(Number(form.count) || 1, 1), 10);
        form.count = count;
        form.values = Array.from({ length: count }, (_, index) => form.values[index] ?? '');
        this.service.render();
    }

    public isComplete(): boolean {
        if (!this.questionnaire.questions.length) return false;
        return this.questionnaire.questions.every(question => {
            const value = this.answers[question.id];
            if (value === undefined || value === null || String(value).trim() === '') return false;
            const measurement = this.measurementForms[question.id];
            if (!measurement) return true;
            return measurement.values.length === Number(measurement.count) &&
                measurement.values.every((item: any) =>
                    item !== '' && item !== null && Number.isFinite(Number(item))
                );
        });
    }

    public async submitSurvey() {
        if (!this.isComplete() || this.submitting) return;
        this.submitting = true;
        await this.service.render();
        const answers = this.questionnaire.questions.map(question => ({
            question_id: question.id,
            value: this.answers[question.id],
            measurement_values: this.measurementForms[question.id]
                ? this.measurementForms[question.id].values.map((value: any) => Number(value))
                : []
        }));
        const formData = new FormData();
        formData.append('facility_id', this.selectedFacility.id);
        formData.append('item_id', this.questionnaire.item.id);
        formData.append('assessment_type', this.questionnaire.assessment.key);
        formData.append('answers', JSON.stringify(answers));
        for (const question of this.questionnaire.questions) {
            for (const photo of this.surveyPhotos[question.id] || []) {
                if (photo?.file) formData.append(`photo_${question.id}[]`, photo.file);
            }
        }
        const result: any = await this.service.file.upload(
            '/wiz/api/page.railway.field.survey/submit',
            formData
        );
        this.submitting = false;
        if (!result || result.code !== 200) {
            await this.service.render();
            await this.service.modal.error(this.message(result?.data, '현장조사를 저장하지 못했습니다.'));
            return;
        }
        this.showSurvey = false;
        this.releaseSurveyPhotoPreviews();
        await this.loadSurveyOverview();
        await this.service.modal.success('시설 현장조사가 저장되었습니다.');
    }

    private async addSurveyPhoto(questionId: string, file: File) {
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
        const hasAllowedExtension = /\.(jpe?g|png|webp)$/i.test(file.name || '');
        if (!allowedTypes.includes(file.type) && !hasAllowedExtension) {
            await this.service.modal.error('JPG, PNG, WEBP 사진만 업로드할 수 있습니다.');
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            await this.service.modal.error('현장 사진은 파일당 10MB 이하로 업로드해주세요.');
            return;
        }

        const photos = this.surveyPhotos[questionId] || [];
        const duplicated = photos.some((photo: any) =>
            photo.file.name === file.name &&
            photo.file.size === file.size &&
            photo.file.lastModified === file.lastModified
        );
        if (duplicated) return;
        photos.push({
            file,
            preview: URL.createObjectURL(file)
        });
        this.surveyPhotos[questionId] = photos;
        await this.service.render();
    }

    private resetAnswers() {
        this.releaseSurveyPhotoPreviews();
        this.answers = {};
        this.measurementForms = {};
        for (const question of this.questionnaire.questions) {
            this.answers[question.id] = '';
        }
    }

    private releaseSurveyPhotoPreviews() {
        for (const questionId of Object.keys(this.surveyPhotos || {})) {
            for (const photo of this.surveyPhotos[questionId] || []) {
                if (photo.preview) URL.revokeObjectURL(photo.preview);
            }
        }
        this.surveyPhotos = {};
    }

    private message(data: any, fallback: string): string {
        if (data && typeof data === 'object' && data.message) return data.message;
        if (typeof data === 'string' && data) return data;
        return fallback;
    }
}

export default PageRailwayFieldSurveyComponent;